export default "./src/client/components/auth/login/open-web/spid-button/img/spid-agid-logo-lb.svg?b5bf8e260ec959b059a640314c2eef92";